module.exports = __webpack_public_path__ + "img/RedteaSIM_04.eabadaff.png";